// components/contribute/ProgressIndicator.js
import TaskAltIcon from '@mui/icons-material/TaskAlt'
import './ProgressIndicator.css'

const steps = [
  { number: 1, title: 'Problem-Details' },
  { number: 2, title: 'Lösung' },
  { number: 3, title: 'Zusatzinfos' },
  { number: 4, title: 'Überprüfung' }
]

function ProgressIndicator ({ currentStep, totalSteps }) {
  return (
    <div className='progress-indicator-contribute'>
      <div className='progress-steps-contribute'>
        {steps.map((step, index) => (
          <div key={step.number} className='progress-step-wrapper-contribute'>
            <div
              className={`progress-step-contribute ${
                currentStep === step.number
                  ? 'active'
                  : currentStep > step.number
                  ? 'completed'
                  : ''
              }`}
            >
              <div className='step-circle-contribute'>
                {currentStep > step.number ? (
                  <TaskAltIcon className='checkmark-contribute' />
                ) : (
                  <span className='step-number-contribute'>{step.number}</span>
                )}
              </div>
              <div className='step-label-contribute'>{step.title}</div>
            </div>
            {index < steps.length - 1 && (
              <div
                className={`progress-line-contribute ${
                  currentStep > step.number ? 'completed' : ''
                }`}
              ></div>
            )}
          </div>
        ))}
      </div>

      <div className='progress-bar-container-contribute'>
        <div
          className='progress-bar-fill-contribute'
          style={{ width: `${(currentStep / totalSteps) * 100}%` }}
        ></div>
      </div>
    </div>
  )
}

export default ProgressIndicator
